import { Container } from '@/atoms';
import { Gallery } from '@/molecules';

import { sectionBgProps } from '@/utils';
import { getRealUrl } from '@/utils/utils';

/**
 * ComponentRevisadasGalleria
 */
export const ComponentRevisadasGalleria = ({
  Imagenes,
  isGrid,
  ConSeccionExtra,
  FondoSeccion,
}: any) => (
  <Container
    wrapper
    {...sectionBgProps(FondoSeccion, 'lg:bg-primary-50')}
    padding="px-4 py-4 md:py-10"
  >
    <Gallery
      images={Imagenes.map((itm: any) => ({
        alt: itm?.alternativeText,
        src: getRealUrl(itm?.url),
      }))}
      flat={{
        codigoUnidadAlquiler: Imagenes?.codigoUnidadAlquiler,
        ventaAlquiler: Imagenes?.ventaAlquiler,
        reservable: Imagenes?.reservable,
        visitable: Imagenes?.visitable,
        nombreUE: Imagenes?.nombreUE,
        cityArea: Imagenes?.tipoZona?.infoAdicional,
      }}
      isGrid={isGrid}
      typeModal={ConSeccionExtra ? 'form' : 'grid'}
    />
  </Container>
);

ComponentRevisadasGalleria.displayName = 'ComponentRevisadasGalleria';
